// config.js
module.exports = {
  id: "apolocrm",
  domain: "wegrou.app",
  wegrou: true,
  siteURL: "https://dashboard.wegrou.app",
  app: {
    apiKey: "AIzaSyA6I2g14lFjw34Bdzs9GGchuFKoADwtb8I",
    authDomain: "apolocrm.firebaseapp.com",
    databaseURL: "https://apolocrm.firebaseio.com",
    projectId: "apolocrm",
    storageBucket: "apolocrm.appspot.com",
    messagingSenderId: "190482760967",
    appId: "1:190482760967:web:482bec552b4602616e31a2",
    measurementId: "G-EQWESMX46D",
  },
  tokens: [
    "lyCyJs4hOcs3rpwBjoUL2J5KPDaPuLDSluEpFO49tU7lwtv+V6hkaZqNcisnjbFSgR18vCFuj3NRZ+PM7LQBnA==",
  ],
  gtm_id: "GTM-KKD979B",
  statitics_url:
    "https://datastudio.google.com/embed/reporting/612a8dc7-1a95-42b9-805a-db827e9f13d6/page/DVWQB",
  report_activities_url:
    "https://datastudio.google.com/embed/reporting/f81f9f21-25f5-4658-8b7e-5c6e12085dff/page/nYLqB",
  fcm_key:
    "BAgQ7SilXRssi87YmaWVTH_DbWcDun3VT7kDijk-9Xb4O4cvqA1AYGvGy9Ma0MtY4X80dkte2zAmizrZm2VcEMA",
  algolia: {
    id: "Y2QUWDCP87",
    key: "9fc6d5208b0b3ba352d9f9918977ecc6",
    admin_key: "1fd6939a911d2bb723c40c4786b01fc3",
  },
  whatsappServerURL: "",
  hideOriginForAdvisors: false,
  allowAllocationSameAgent: false,
  allowAllocationByPortion: false,
  contactImportData: [
    {
      header: "Nombres",
      key: "name",
      width: 30,
      outlineLevel: 1,
      type: "string",
    },
    {
      header: "Apellidos",
      key: "last_name",
      width: 30,
      outlineLevel: 1,
      type: "string",
    },
    {
      header: "Tipo de documento",
      key: "document_type",
      width: 20,
      type: "string",
    },
    {
      header: "Número de documento",
      key: "document_number",
      width: 20,
      type: "string",
    },
    {
      header: "Correo electrónico",
      key: "email",
      width: 20,
      outlineLevel: 1,
      type: "email",
    },
    {
      header: "Teléfono",
      key: "phone",
      width: 20,
      outlineLevel: 1,
      type: "string",
    },
    { header: "Institución", key: "company", width: 20, type: "string" },
    { header: "Cargo", key: "position", width: 20, type: "string" },
    { header: "Comentario", key: "comment", width: 20, type: "string" },
    {
      header: "Correo del Encargado",
      key: "agent_id",
      width: 20,
      type: "agent",
    },
    { header: "Origen", key: "origin", width: 20, type: "string" },
  ],
  contactExportData: [
    { header: "Nombres", key: "name", type: "string", width: 30 },
    { header: "Apellidos", key: "last_name", type: "last_name", width: 30 },
    {
      header: "Tipo de documento",
      key: "document_type",
      width: 20,
      type: "string",
    },
    {
      header: "Número de documento",
      key: "document_number",
      width: 20,
      type: "string",
    },
    { header: "Correo electrónico", key: "email", type: "email", width: 30 },
    { header: "Teléfono", key: "phone", type: "string", width: 20 },
    { header: "Institución", key: "company", width: 20, type: "string" },
    { header: "Cargo", key: "position", width: 20, type: "string" },
    { header: "Comentario", key: "comment", width: 20, type: "string" },
    { header: "Etiquetas", key: "tags", width: 20, type: "tags" },
    { header: "Encargado", key: "agent_id", type: "agent", width: 20 },
    {
      header: "¿Aceptó términos y condiciones?",
      key: "terms",
      type: "terms",
      width: 20,
    },
    {
      header: "Última actividad",
      key: "last_comment",
      type: "string",
      width: 20,
    },
    {
      header: "Fecha de última actividad",
      key: "last_activity",
      type: "timestamp",
      width: 20,
    },
    {
      header: "Fecha de registro",
      key: "created_at",
      type: "timestamp",
      width: 20,
    },
    { header: "Origen", key: "origin", type: "string", width: 20 },
  ],
  contactFilters: {
    country: { id: "country", name: "País", primary: true },
  },
  contactFormSchema: {
    name: {
      type: "text",
      label: "Nombres",
      placeholder: "Nombres",
      flex: { xs: 12, sm: 6 },
      rules: [(v) => !!v || "Campo requerido"],
      show_on_detail: true,
      form_update: true,
      searchable: true,
    },
    last_name: {
      type: "text",
      label: "Apellidos",
      placeholder: "Apellidos",
      flex: { xs: 12, sm: 6 },
      rules: [(v) => !!v || "Campo requerido"],
      show_on_detail: true,
      form_update: true,
      searchable: true,
    },
    document_type: {
      type: "select",
      label: "Tipo de documento",
      placeholder: "Tipo de documento",
      items: ["DNI", "Carnet de extranjería", "RUC"],
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
      searchable: true,
    },
    document_number: {
      type: "text",
      label: "Número de documento",
      placeholder: "Número de documento",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
      searchable: true,
    },
    phone: {
      type: "text",
      label: "Teléfono",
      placeholder: "Teléfono",
      flex: { xs: 12, sm: 6 },
      rules: [
        (v) =>
          // eslint-disable-next-line
          /^$|^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/.test(v) ||
          "Teléfono no válido",
      ],
      show_on_detail: true,
      form_update: true,
    },
    email: {
      type: "email",
      label: "Correo electrónico",
      placeholder: "Correo electrónico",
      flex: { xs: 12 },
      rules: [
        (v) => !!v || "Campo requerido",
        (v) =>
          // eslint-disable-next-line
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "Correo electrónico no válido",
      ],
      show_on_detail: true,
      searchable: true,
    },
    country: {
      type: "autocomplete",
      label: "País",
      items: [],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6, md: 4 },
      show_on_detail: true,
      form_update: true,
    },
    city: {
      type: "combobox",
      label: "Departamento",
      items: [],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6, md: 4 },
      show_on_detail: true,
      form_update: true,
    },
    district: {
      type: "text",
      label: "Distrito",
      items: [],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6, md: 4 },
      show_on_detail: true,
      form_update: true,
    },
    comment: {
      type: "text",
      label: "Comentario",
      placeholder: "Comente aquí",
      flex: { xs: 12 },
    },
    agent: {
      type: "select",
      label: "Encargado",
      items: [],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
    },
    newsletter: {
      type: "checkbox",
      label: "Desea recibir ofertas y promociones de Wegrou",
      flex: { xs: 12 },
      class: "pt-5",
    },
    terms: {
      type: "checkbox",
      label: "Aceptó los términos y condiciones de Wegrou",
      flex: { xs: 12 },
    },
    tags: {
      type: "hidden",
      label: "Etiquetas",
      flex: { xs: 12 },
    },
  },
  tableContact: [
    {
      text: "Contacto",
      align: "center",
      sortable: false,
      value: "full_name",
    },
    {
      text: "Número de documento",
      align: "center",
      sortable: false,
      value: "document_number",
    },
    {
      text: "Email",
      align: "center",
      sortable: false,
      value: "email",
    },
    {
      text: "País",
      align: "center",
      sortable: false,
      value: "country",
    },
    {
      text: "Registrado",
      align: "center",
      value: "created_at",
      sortable: true,
    },
    {
      text: "Operación",
      align: "center",
      sortable: false,
      value: "operations",
    },
  ],
  contactActivityImportData: [
    {
      header: "Correo electrónico",
      key: "contact_email",
      width: 20,
      outlineLevel: 1,
      type: "email",
    },
    {
      header: "Tipo de actividad",
      key: "activity_type",
      width: 20,
      type: "activity",
    },
    { header: "Comentario", key: "comment", width: 40, type: "string" },
  ],
  orderImportData: [
    {
      label: "Número de boleta*",
      key: "invoice_number",
      type: "string",
      required: true,
    },
    {
      label: "DNI/RUC",
      key: "document_number",
      type: "string",
    },
    {
      label: "Nombres",
      key: "name",
      type: "string",
    },
    {
      label: "Apellidos",
      key: "last_name",
      type: "string",
    },
    {
      label: "Correo electrónico",
      key: "email",
      type: "email",
    },
    {
      label: "Teléfono",
      key: "phone",
      type: "string",
    },
    {
      label: "Categoría del producto",
      key: "category",
      type: "string",
      isProductAttribute: true,
    },
    {
      label: "Dirección",
      key: "address",
      type: "string",
    },
    {
      label: "Nombre producto*",
      key: "product_name",
      width: 20,
      type: "string",
      isProductAttribute: true,
    },
    {
      label: "Cantidad producto",
      key: "product_quantity",
      width: 20,
      type: "number",
      isProductAttribute: true,
    },
    {
      label: "Precio producto (precio por unidad)",
      key: "product_price",
      width: 20,
      type: "number",
      isProductAttribute: true,
    },
    { label: "Descuento", key: "discount", type: "number" },
    {
      label: "Total venta*",
      key: "total_paid",
      type: "number",
      required: true,
    },
    {
      label: "Método de pago",
      key: "payment_method",
      type: "string",
    },
    {
      label: "Fecha de venta* (dd/mm/yyyy)",
      key: "sold_at",
      type: "date",
      required: true,
    },
  ],
  saleExportData: [
    { header: "Id", key: "id", type: "string", width: 30 },
    {
      header: "Nombres",
      key: "name",
      type: "string",
      width: 30,
      show_on_detail: true,
    },
    {
      header: "Apellidos",
      key: "last_name",
      type: "last_name",
      width: 30,
      show_on_detail: true,
    },
    {
      header: "Tipo de documento",
      key: "document_type",
      type: "string",
      width: 30,
      show_on_detail: true,
    },
    {
      header: "Número de documento",
      key: "document_number",
      type: "string",
      width: 30,
      show_on_detail: true,
    },
    {
      header: "Correo electrónico",
      key: "email",
      type: "email",
      width: 30,
      show_on_detail: true,
    },
    {
      header: "Teléfono",
      key: "phone",
      type: "string",
      width: 20,
      show_on_detail: true,
    },
    {
      header: "Dirección",
      key: "address",
      type: "string",
      width: 20,
      show_on_detail: true,
    },
    {
      header: "Producto/Cantidad/Precio",
      key: "products",
      type: "products",
      width: 30,
    },
    { header: "Descuento", key: "discount", width: 20, type: "number" },
    {
      header: "Total en productos",
      key: "total_products",
      type: "number",
      width: 20,
    },
    {
      header: "Total en delivery",
      key: "total_delivery",
      type: "number",
      width: 20,
    },
    {
      header: "Total venta",
      key: "total_paid",
      type: "number",
      default: true,
      width: 20,
    },
    {
      header: "Estado de pago",
      key: "payment_state",
      width: 20,
      type: "string",
    },
    {
      header: "Método de pago",
      key: "payment_method",
      type: "string",
      width: 20,
    },
    {
      header: "Estado de entrega",
      key: "delivery_state",
      width: 20,
      type: "string",
    },
    {
      header: "Método de entrega",
      key: "delivery_method",
      width: 20,
      type: "string",
    },
    {
      header: "Tienda",
      key: "store_id",
      width: 20,
      type: "store",
    },
    {
      header: "Dirección de entrega",
      key: "address",
      parent: "delivery",
      width: 20,
      type: "string",
    },
    {
      header: "Referencia",
      key: "reference",
      parent: "delivery",
      width: 20,
      type: "string",
    },
    { header: "Encargado", key: "agent_id", width: 20, type: "agent" },
    { header: "Origen", key: "origin", width: 20, type: "string" },
    {
      header: "Fecha de registro",
      key: "created_at",
      type: "timestamp",
      width: 20,
    },
    {
      header: "Fecha de venta",
      key: "sold_at",
      type: "timestamp",
      width: 20,
    },
    {
      header: "Agente que importó la venta",
      key: "import_by",
      width: 20,
      type: "agent",
    },
  ],
  orderFilters: {
    payment_state: {
      id: "payment_state",
      name: "Estado de pago",
      primary: true,
    },
    delivery_state: {
      id: "delivery_state",
      name: "Estado de entrega",
      primary: true,
    },
    products_ids: { id: "products_ids", name: "Producto", primary: true },
  },
  orderPaymentMethods: [
    { id: "DEB_CRED", name: "Tarjeta de crédito/débito" },
    { id: "TRANSFER", name: "Transferencia" },
    { id: "YAPE", name: "Yape" },
    { id: "UPON_DELIVERY", name: "Contra entrega" },
  ],
  orderPaymentStates: [
    {
      id: "pago-pendiente",
      name: "Pago pendiente",
      hashtag: "#o{OrdenID}eppen",
      abrev: "pen",
    },
    {
      id: "procesando-pago",
      name: "Procesando pago",
      hashtag: "#o{OrdenID}eppro",
      abrev: "pro",
    },
    {
      id: "pago-rechazado",
      name: "Pago rechazado",
      hashtag: "#o{OrdenID}eprec",
      abrev: "rec",
    },
    {
      id: "pago-completado",
      name: "Pago completado",
      hashtag: "#o{OrdenID}epcom",
      abrev: "com",
    },
  ],
  orderDeliveryMethods: [
    { id: "store", name: "Entrega en tienda" },
    { id: "address", name: "Entrega a domicilio" },
  ],
  orderDeliveryStates: [
    {
      id: "pendiente-de-entrega",
      name: "Pendiente de entrega",
      hashtag: "#o{OrdenID}eepen",
      abrev: "pen",
    },
    {
      id: "enviando-pedido",
      name: "Enviando pedido",
      hashtag: "#o{OrdenID}eeenv",
      abrev: "env",
    },
    {
      id: "pedido-entregado",
      name: "Pedido entregado",
      hashtag: "#o{OrdenID}eeent",
      abrev: "ent",
    },
    {
      id: "pedido-no-recibido",
      name: "Pedido no recibido",
      hashtag: "#o{OrdenID}eenre",
      abrev: "nre",
    },
  ],
  orderFormSchema: {
    name: {
      type: "text",
      label: "Nombres",
      placeholder: "Nombres",
      flex: { xs: 12, sm: 6 },
      rules: ["required"],
      sort: 2,
      searchable: true,
    },
    last_name: {
      type: "text",
      label: "Apellidos",
      placeholder: "Apellidos",
      flex: { xs: 12, sm: 6 },
      sort: 3,
      searchable: true,
      value: "",
    },
    document_type: {
      type: "select",
      label: "Tipo de documento",
      items: ["DNI", "Carnet de extranjería", "RUC"],
      placeholder: "Seleccione",
      rules: ["required"],
      flex: { sm: 6 },
      sort: 4,
      value: "DNI",
      searchable: true,
    },
    document_number: {
      type: "text",
      label: "Número de documento",
      placeholder: "Número de documento",
      rules: ["required"],
      flex: { sm: 6 },
      sort: 5,
      searchable: true,
    },
    email: {
      type: "email",
      label: "Correo electrónico",
      placeholder: "Correo electrónico",
      flex: { xs: 12 },
      rules: ["email"],
      sort: 6,
      searchable: true,
    },
    phone: {
      type: "text",
      label: "Teléfono",
      placeholder: "Teléfono",
      flex: { xs: 12, sm: 6 },
      sort: 7,
      searchable: true,
    },
    origin: {
      type: "autocomplete",
      label: "Origen",
      items: [
        "whatsApp",
        "facebook",
        "instagram",
        "twitter",
        "linkedIn",
        "tienda",
      ],
      placeholder: "Seleccione",
      rules: ["required"],
      flex: { xs: 12, sm: 6 },
      sort: 9,
    },
  },
  ticketFilters: {
    state: { id: "state", name: "Estado", primary: true },
    origin: { id: "origin", name: "Origen", primary: true },
    agent_id: {
      id: "agent_id",
      name: "Agente",
      primary: true,
      readonly_advisor: true,
      item_text: "full_name",
      item_value: "uid",
    },
  },
  tableTicket: [
    {
      text: "Contacto",
      align: "center",
      sortable: false,
      value: "full_name",
    },
    {
      text: "Estado",
      align: "center",
      sortable: false,
      value: "state",
    },
    {
      text: "Registrado",
      align: "center",
      value: "created_at",
      sortable: true,
    },
    {
      text: "Origen",
      align: "center",
      sortable: false,
      value: "origin",
    },
    {
      text: "Encargado",
      align: "center",
      sortable: false,
      value: "agent_id",
    },
    {
      text: "Operación",
      align: "right",
      sortable: false,
      value: "operations",
    },
  ],
  ticketFormSchema: {
    ticket_name: {
      type: "text",
      label: "Nombre del ticket",
      placeholder: "Nombre del ticket",
      flex: { xs: 12 },
      show_on_detail: true,
      form_update: true,
      sort: 1,
    },
    name: {
      type: "text",
      label: "Nombres",
      placeholder: "Nombres",
      flex: { xs: 12, sm: 6 },
      rules: [(v) => !!v || "Campo requerido"],
      landing_rules: ["required"],
      show_on_detail: true,
      form_update: true,
      first_word: "Nombre: ",
      show_on_landing: true,
      sort: 2,
      searchable: true,
    },
    last_name: {
      type: "text",
      label: "Apellidos",
      placeholder: "Apellidos",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
      sort: 3,
      searchable: true,
    },
    document_type: {
      type: "select",
      label: "Tipo de documento",
      placeholder: "Seleccione",
      items: ["DNI", "Carnet de extranjería"],
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
      sort: 4,
    },
    document_number: {
      type: "text",
      label: "Número de documento",
      placeholder: "Número de documento",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
      sort: 5,
      searchable: true,
    },
    phone: {
      type: "text",
      label: "Teléfono",
      placeholder: "Teléfono",
      flex: { xs: 12, sm: 6 },
      landing_rules: ["required"],
      show_on_detail: true,
      show_on_landing: true,
      sort: 6,
      searchable: true,
    },
    email: {
      type: "email",
      label: "Correo electrónico",
      placeholder: "Correo electrónico",
      flex: { xs: 12, sm: 6 },
      rules: [
        (v) =>
          // eslint-disable-next-line
          !v ||
          (!!v &&
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              v
            )) ||
          "Correo electrónico no válido",
      ],
      landing_rules: ["required", "email"],
      show_on_detail: true,
      show_on_landing: true,
      sort: 7,
      searchable: true,
    },
    country: {
      type: "autocomplete",
      label: "País",
      items: [],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6, md: 4 },
      show_on_detail: true,
      form_update: true,
    },
    city: {
      type: "combobox",
      label: "Departamento",
      items: [],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6, md: 4 },
      show_on_detail: true,
      form_update: true,
    },
    district: {
      type: "text",
      label: "Distrito",
      items: [],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6, md: 4 },
      show_on_detail: true,
      form_update: true,
    },
    birthdate: {
      type: "text",
      label: "Año de Nacimiento",
      placeholder: "Año de Nacimiento",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    company: {
      type: "text",
      label: "Institución",
      placeholder: "Institución",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    position: {
      type: "text",
      label: "Cargo",
      placeholder: "Cargo",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    plan: {
      type: "select",
      label: "Plan",
      items: ["Profesional", "Premium", "Dedicado"],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    etapa: {
      type: "select",
      label: "¿Cuentas con una idea, proyecto o negocio?",
      items: [
        "Aún no pero me interesa emprender",
        "Idea",
        "Proyecto",
        "Negocio",
      ],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    product_or_service: {
      type: "select",
      label: "¿Ofrece un producto o servicio?",
      items: ["Producto", "Servicio"],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    rubro: {
      type: "select",
      label: "¿En qué rubro?",
      items: [
        "Comercio",
        "Servicios",
        "Alimentos",
        "Manufactura",
        "Construcción",
        "Agropecuario",
        "Minería",
        "Pesca",
        "Otros",
      ],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    number_workers: {
      type: "text",
      label: "¿Cuantas personas trabajan en tu proyecto?",
      placeholder: "¿Cuantas personas trabajan en tu proyecto?",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    social_networks: {
      type: "text",
      label: "Redes sociales",
      placeholder: "Redes sociales",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    area_to_improve: {
      type: "select",
      label: "¿En qué área te gustaría mejorar tu negocio?",
      items: [
        "Marketing",
        "Ventas",
        "Sistemas",
        "Finanzas",
        "Legal",
        "Contabilidad",
        "Operaciones",
        "Otros",
      ],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    how_help: {
      type: "text",
      label: "¿Cómo te podemos ayudar?",
      placeholder: "¿Cómo te podemos ayudar?",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    would_be_member: {
      type: "select",
      label:
        "¿Te gustaría ser miembro de esta comunidad y mantenerte al tanto de nuestras novedades?",
      placeholder: "¿Te gustaría ser miembro?",
      items: ["Sí", "No"],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    use_ads: {
      type: "select",
      label: "¿Están utilizando anuncios digitales para adquirir clientes?",
      placeholder:
        "¿Están utilizando anuncios digitales para adquirir clientes?",
      items: ["Sí", "No"],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    use_ads_before_pandemic: {
      type: "select",
      label: "¿Ya realizaban estos anuncios antes de la pandemia?",
      placeholder: "¿Ya realizaban estos anuncios antes de la pandemia?",
      items: ["Sí", "No"],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    use_landing_pages: {
      type: "select",
      label:
        "¿Utilizan landing pages adicionales a su sitio web para optimizar estas campañas?",
      placeholder:
        "¿Utilizan landing pages adicionales a su sitio web para optimizar estas campañas?",
      items: ["Sí", "No"],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    measure_campaigns: {
      type: "select",
      label:
        "¿Miden las finanzas de sus campañas de marketing (Ratios de conversión, Costos de adquisición de clientes, Valor de vida del cliente, Ratio de abandono)?",
      placeholder:
        "¿Miden las finanzas de sus campañas de marketing (Ratios de conversión, Costos de adquisición de clientes, Valor de vida del cliente, Ratio de abandono)?",
      items: ["Sí", "No"],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    use_google_analytics: {
      type: "select",
      label: "¿Utilizan Google Analytics para medir las fuentes de tráfico?",
      placeholder:
        "¿Utilizan Google Analytics para medir las fuentes de tráfico?",
      items: ["Sí", "No"],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    budget_to_marketing: {
      type: "select",
      label:
        "¿Cuentan con presupuesto mensual de marketing alineado con el valor de su Costo de adquisición de clientes?",
      placeholder:
        "¿Cuentan con presupuesto mensual de marketing alineado con el valor de su Costo de adquisición de clientes?",
      items: ["Sí", "No"],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    have_team_asesors: {
      type: "select",
      label: "¿Cuentan con un equipo de vendedores? ¿De qué tamaño?",
      placeholder: "¿Cuentan con un equipo de vendedores? ¿De qué tamaño?",
      items: ["Sí", "No"],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    make_marketing_direct: {
      type: "select",
      label:
        "Realizan acciones de marketing directo (¿Como el envío de correos electrónicos hacia su base de datos?)",
      placeholder:
        "Realizan acciones de marketing directo (¿Como el envío de correos electrónicos hacia su base de datos?)",
      items: ["Sí", "No"],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    use_any_crm: {
      type: "select",
      label: "¿Utilizan una herramienta CRM?",
      placeholder: "¿Utilizan una herramienta CRM?",
      items: ["Sí", "No"],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
    },
    quotation_code: {
      type: "text",
      label: "Código de cotización",
      placeholder: "Código de cotización",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      sort: 12,
      searchable: true,
    },
    quotation_date_expired: {
      type: "date",
      data_type: "date",
      label: "Fecha de expiración de cotización",
      placeholder: "Fecha de expiración de cotización",
      ext: "text",
      menu: {
        closeOnContentClick: true,
        nudgeRight: 200,
      },
      locale: "es",
      appendIcon: "far fa-calendar-alt",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      form_update: true,
      sort: 13,
    },
    comment: {
      type: "text",
      label: "Comentario",
      placeholder: "Comente aquí",
      flex: { xs: 12 },
    },
    medium_contact: {
      type: "select",
      label: "Medio de contacto",
      items: [
        "Whatsapp",
        "Facebook",
        "Instagram",
        "Web",
        "Llamada",
        "Correo",
        "Sala de ventas",
        "Consulta",
        "Evento",
      ],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
      rules: [(v) => !!v || "Campo requerido"],
      show_on_detail: true,
      form_update: true,
    },
    agent: {
      type: "select",
      label: "Encargado",
      items: [],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
    },
    origin: {
      type: "autocomplete",
      label: "Origen",
      items: [],
      placeholder: "Seleccione",
      flex: { xs: 12, sm: 6 },
    },
    tags: {
      type: "hidden",
      data_type: "tags",
      label: "Etiquetas",
      flex: { xs: 12 },
    },
    terms: {
      type: "hidden",
      data_type: "boolean",
      label: "Terminos y condiciones",
      flex: { xs: 12 },
    },
  },
  ticketImportData: [
    {
      header: "Nombre del Ticket",
      key: "ticket_name",
      type: "string",
      width: 30,
    },
    {
      header: "Nombres*",
      key: "name",
      width: 30,
      type: "string",
      validate: true,
      required: true,
    },
    {
      header: "Apellidos",
      key: "last_name",
      width: 30,
      type: "string",
    },
    {
      header: "Tipo de documento",
      key: "document_type",
      width: 20,
      type: "string",
    },
    {
      header: "Número de documento",
      key: "document_number",
      width: 20,
      type: "string",
    },
    {
      header: "Correo electrónico",
      key: "email",
      width: 20,
      type: "email",
    },
    {
      header: "Teléfono",
      key: "phone",
      width: 20,
      outlineLevel: 1,
      type: "string",
    },
    {
      header: "Institución",
      key: "company",
      width: 20,
      outlineLevel: 1,
      type: "string",
    },
    {
      header: "Cargo",
      key: "position",
      width: 20,
      outlineLevel: 1,
      type: "string",
    },
    { header: "Plan", key: "plan", width: 20, type: "string" },
    {
      header: "¿Cuentas con una idea, proyecto o negocio?",
      key: "etapa",
      width: 20,
      type: "string",
    },
    {
      header: "¿Ofrece un producto o servicio?",
      key: "product_or_service",
      width: 20,
      type: "string",
    },
    {
      header: "¿Cuentas personas trabajan en tu proyecto?",
      key: "number_workers",
      width: 20,
      type: "string",
    },
    { header: "Rubro", key: "rubro", width: 20, type: "string" },
    {
      header: "Redes sociales",
      key: "social_networks",
      width: 20,
      type: "string",
    },
    {
      header: "¿En qué área te gustaría mejorar?",
      key: "area_to_improve",
      width: 20,
      type: "string",
    },
    {
      header: "¿Cómo te podemos ayudar?",
      key: "how_help",
      width: 20,
      type: "string",
    },
    {
      header:
        "¿Te gustaría ser miembro de esta comunidad y mantenerte al tanto de nuestras novedades?",
      key: "would_be_member",
      width: 20,
      type: "string",
    },
    {
      header: "¿Están utilizando anuncios digitales para adquirir clientes?",
      key: "use_ads",
      width: 20,
      type: "string",
    },
    {
      header: "¿Ya realizaban estos anuncios antes de la pandemia?",
      key: "use_ads_before_pandemic",
      width: 20,
      type: "string",
    },
    {
      header:
        "¿Utilizan landing pages adicionales a su sitio web para optimizar estas campañas?",
      key: "use_landing_pages",
      width: 20,
      type: "string",
    },
    {
      header: "¿Miden las finanzas de sus campañas de marketing?",
      key: "measure_campaigns",
      width: 20,
      type: "string",
    },
    {
      header: "¿Utilizan Google Analytics para medir las fuentes de tráfico?",
      key: "use_google_analytics",
      width: 20,
      type: "string",
    },
    {
      header:
        "¿Cuentan con presupuesto mensual de marketing alineado con el valor de su Costo de adquisición de clientes?",
      key: "budget_to_marketing",
      width: 20,
      type: "string",
    },
    {
      header: "¿Cuentan con un equipo de vendedores?",
      key: "have_team_asesors",
      width: 20,
      type: "string",
    },
    {
      header: "Realizan acciones de marketing directo",
      key: "make_marketing_direct",
      width: 20,
      type: "string",
    },
    {
      header: "¿Utilizan una herramienta CRM?",
      key: "use_any_crm",
      width: 20,
      type: "string",
    },
    { header: "Comentario", key: "comment", width: 20, type: "string" },
    {
      header: "Correo del Encargado",
      key: "agent_id",
      width: 20,
      type: "agent",
      validate: true,
    },
    {
      header: "Origen*",
      key: "origin",
      width: 20,
      type: "string",
      validate: true,
      required: true,
    },
    {
      header: "Términos y condiciones (si/no)",
      key: "terms",
      width: 20,
      type: "boolean",
    },
  ],
  ticketExportData: [
    { header: "Ticket ID", key: "id", type: "string", width: 30 },
    {
      header: "Nombre del ticket",
      key: "ticket_name",
      type: "string",
      width: 30,
    },
    { header: "Nombres", key: "name", type: "string", width: 30 },
    { header: "Apellidos", key: "last_name", type: "last_name", width: 30 },
    {
      header: "Tipo de documento",
      key: "document_type",
      width: 20,
      type: "string",
    },
    {
      header: "Número de documento",
      key: "document_number",
      width: 20,
      type: "string",
    },
    { header: "Correo electrónico", key: "email", type: "email", width: 30 },
    { header: "Teléfono", key: "phone", type: "string", width: 20 },
    { header: "Plan", key: "plan", width: 20, type: "string" },
    {
      header: "¿Cuentas con una idea, proyecto o negocio?",
      key: "etapa",
      width: 20,
      type: "string",
    },
    {
      header: "¿Ofrece un producto o servicio?",
      key: "product_or_service",
      width: 20,
      type: "string",
    },
    {
      header: "¿Cuentas personas trabajan en tu proyecto?",
      key: "number_workers",
      width: 20,
      type: "string",
    },
    { header: "Rubro", key: "rubro", width: 20, type: "string" },
    {
      header: "Redes sociales",
      key: "social_networks",
      width: 20,
      type: "string",
    },
    {
      header: "¿En qué área te gustaría mejorar?",
      key: "area_to_improve",
      width: 20,
      type: "string",
    },
    {
      header: "¿Cómo te podemos ayudar?",
      key: "how_help",
      width: 20,
      type: "string",
    },
    {
      header:
        "¿Te gustaría ser miembro de esta comunidad y mantenerte al tanto de nuestras novedades?",
      key: "would_be_member",
      width: 20,
      type: "string",
    },
    {
      header: "¿Están utilizando anuncios digitales para adquirir clientes?",
      key: "use_ads",
      width: 20,
      type: "string",
    },
    {
      header: "¿Ya realizaban estos anuncios antes de la pandemia?",
      key: "use_ads_before_pandemic",
      width: 20,
      type: "string",
    },
    {
      header:
        "¿Utilizan landing pages adicionales a su sitio web para optimizar estas campañas?",
      key: "use_landing_pages",
      width: 20,
      type: "string",
    },
    {
      header: "¿Miden las finanzas de sus campañas de marketing?",
      key: "measure_campaigns",
      width: 20,
      type: "string",
    },
    {
      header: "¿Utilizan Google Analytics para medir las fuentes de tráfico?",
      key: "use_google_analytics",
      width: 20,
      type: "string",
    },
    {
      header:
        "¿Cuentan con presupuesto mensual de marketing alineado con el valor de su Costo de adquisición de clientes?",
      key: "budget_to_marketing",
      width: 20,
      type: "string",
    },
    {
      header: "¿Cuentan con un equipo de vendedores?",
      key: "have_team_asesors",
      width: 20,
      type: "string",
    },
    {
      header: "Realizan acciones de marketing directo",
      key: "make_marketing_direct",
      width: 20,
      type: "string",
    },
    {
      header: "¿Utilizan una herramienta CRM?",
      key: "use_any_crm",
      width: 20,
      type: "string",
    },
    { header: "Proyecto", key: "project", type: "string", width: 20 },
    { header: "Comentario", key: "comment", width: 20, type: "string" },
    { header: "Estado", key: "state", type: "state", width: 20 },
    { header: "Etiquetas", key: "tags", width: 20, type: "tags" },
    { header: "Encargado", key: "agent_id", type: "agent", width: 20 },
    {
      header: "Fecha de registro",
      key: "created_at",
      type: "timestamp",
      width: 20,
    },
    {
      header: "Última actividad",
      key: "last_comment",
      type: "string",
      width: 20,
    },
    {
      header: "Fecha de última actividad",
      key: "last_activity",
      type: "timestamp",
      width: 20,
    },
    { header: "Origen", key: "origin", type: "string", width: 20 },
  ],
  ticketActivityImportData: [
    {
      header: "ID del Ticket",
      key: "ticket_id",
      width: 20,
      outlineLevel: 1,
      type: "string",
    },
    {
      header: "Tipo de actividad",
      key: "activity_type",
      width: 20,
      type: "activity",
    },
    { header: "Comentario", key: "comment", width: 40, type: "string" },
  ],
  orderFormSchema: {
    name: {
      type: "text",
      label: "Nombres",
      placeholder: "Nombres",
      flex: { xs: 12, sm: 6 },
      rules: ["required"],
      order: 2,
      searchable: true,
    },
    last_name: {
      type: "text",
      label: "Apellidos",
      placeholder: "Apellidos",
      flex: { xs: 12, sm: 6 },
      order: 3,
      searchable: true,
    },
    phone: {
      type: "text",
      label: "Teléfono",
      placeholder: "Teléfono",
      flex: { xs: 12, sm: 6 },
      order: 4,
    },
    phone_secondary: {
      type: "text",
      label: "Teléfono convencional",
      placeholder: "Teléfono convencional",
      flex: { xs: 12, sm: 6 },
      show_on_detail: true,
      first_word: "Teléfono convencional: ",
      show_on_landing: true,
      order: 5,
    },
    email: {
      type: "email",
      label: "Correo electrónico",
      placeholder: "Correo electrónico",
      flex: { xs: 12 },
      rules: ["required", "email"],
      order: 6,
      searchable: true,
    },
    document_type: {
      type: "select",
      label: "Tipo de documento",
      items: ["DNI", "Carnet de extranjería"],
      placeholder: "Seleccione",
      flex: { sm: 6 },
      order: 7,
    },
    document_number: {
      type: "text",
      label: "Número de documento",
      placeholder: "Número de documento",
      flex: { sm: 6 },
      order: 7,
      searchable: true,
    },
    origin: {
      type: "autocomplete",
      label: "Origen",
      items: [
        "whatsApp",
        "facebook",
        "instagram",
        "twitter",
        "linkedIn",
        "tienda",
      ],
      placeholder: "Seleccione",
      rules: ["required"],
      flex: { xs: 12, sm: 6 },
      order: 9,
    },
  },
  agentTable: [
    {
      text: "Nombres y Apellidos",
      align: "left",
      value: "full_name",
    },
    {
      text: "Correo electrónico",
      align: "left",
      value: "email",
    },
    {
      text: "Rol",
      align: "center",
      sortable: false,
      value: "role",
    },
    {
      text: "Tiendas",
      align: "center",
      value: "stores",
    },
    {
      text: "Proyectos",
      align: "center",
      value: "projects",
    },
    {
      text: "Estado",
      align: "center",
      sortable: false,
      value: "active",
    },
    {
      text: "Operación",
      align: "center",
      sortable: false,
      value: "operations",
    },
  ],
  agentFormSchema: {
    name: {
      type: "text",
      label: "Nombres",
      placeholder: "Nombres",
      flex: { xs: 12, sm: 6 },
      rules: [(v) => !!v || "Campo requerido"],
      show_on_detail: true,
      form_update: true,
    },
    last_name: {
      type: "text",
      label: "Apellidos",
      placeholder: "Apellidos",
      flex: { xs: 12, sm: 6 },
      rules: [(v) => !!v || "Campo requerido"],
      show_on_detail: true,
      form_update: true,
    },
    email: {
      type: "email",
      label: "Correo electrónico",
      placeholder: "Correo electrónico",
      flex: { xs: 12 },
      rules: [
        (v) => !!v || "Campo requerido",
        (v) =>
          // eslint-disable-next-line
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "Correo electrónico no válido",
      ],
      show_on_detail: true,
    },
  },
  campaignTable: [
    {
      text: "Canal",
      align: "center",
      value: "channel",
    },
    {
      text: "Campaña",
      align: "center",
      value: "campaign_name",
    },
    {
      text: "Ciudad",
      align: "center",
      value: "city",
    },
    {
      text: "Distrito",
      align: "center",
      value: "district",
    },
    {
      text: "Edad mínima",
      align: "center",
      value: "min_age",
    },
    {
      text: "Edad máxima",
      align: "center",
      value: "max_age",
    },
    {
      text: "Registros",
      align: "center",
      value: "count_records",
    },
    {
      text: "Presupuesto",
      align: "center",
      value: "amount",
    },
    {
      text: "CAR",
      align: "center",
      value: "car",
    },
    {
      text: "Fecha de inicio",
      align: "center",
      value: "campaign_date",
    },
    {
      text: "Fecha de fin",
      align: "center",
      value: "campaign_end_date",
    },
  ],
  campaignBudgetExportData: [
    {
      header: "Canal",
      key: "channel",
      type: "string",
      width: 30,
    },
    {
      header: "Campaña",
      key: "campaign_name",
      type: "string",
      width: 30,
    },
    {
      header: "Ciudad",
      key: "city",
      type: "string",
      width: 20,
    },
    {
      header: "Distrito",
      key: "district",
      type: "string",
      width: 20,
    },
    {
      header: "Edad mínima",
      key: "min_age",
      width: 15,
      type: "string",
    },
    {
      header: "Edad máxima",
      key: "max_age",
      width: 15,
      type: "string",
    },
    {
      header: "Registros",
      key: "count_records",
      type: "number",
      width: 10,
    },
    {
      header: "Presupuesto",
      key: "amount",
      type: "number",
      width: 15,
    },
    {
      header: "CAR",
      key: "car",
      type: "number",
      width: 10,
    },
    {
      header: "Fecha de inicio",
      key: "campaign_date",
      width: 30,
      type: "timestamp",
    },
    {
      header: "Fecha de fin",
      key: "campaign_end_date",
      type: "timestamp",
      width: 30,
    },
  ],
  theme: {
    // dark: true,
    themes: {
      light: {
        primary: "#027881",
        secondary: "#492cdd",
        secondary: "#9AD8DA",
        accent: "#F9E052",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FB8C00",
        background: "#f6f7f9",
        backgroundscreem: "#f1f4fa",
      },
      dark: {
        primary: "#ffffff",
        secondary: "#492cdd",
        accent: "#9AD8DA",
        error: "#cf6679",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FB8C00",
        // background:"#292930",
        background: "#121212",
        surface: "#ffffff",
      },
    },
  },
};
